const item = "_item_dyt4i_8";
const interactive = "_interactive_dyt4i_26";
const label = "_label_dyt4i_34";
const icon = "_icon_dyt4i_50";
const disabled = "_disabled_dyt4i_118";
const styles = {
  item,
  interactive,
  "no-label": "_no-label_dyt4i_30",
  label,
  "no-icon": "_no-icon_dyt4i_41",
  icon,
  "nav-hint": "_nav-hint_dyt4i_59",
  disabled
};
export {
  styles as default,
  disabled,
  icon,
  interactive,
  item,
  label
};
//# sourceMappingURL=MenuItem.module.css.js.map
